customElements.get('masseria-purchase-options') || customElements.define('masseria-purchase-options',
  class extends HTMLElement {
    constructor() {
      super()
      this.sellingPlanId;
      this.sellingPlanIdProductFormInput = document.getElementById('masseria-selling-plan-id') || null;
      this.salePriceContainer = this.querySelector('#masseria-sale-price') || null;
      this.oneTimeVariantId = this.dataset.oneTimeId || null;
      this.subscriptionId = this.dataset.subscriptionId || null;
      this.productFormValue = document.querySelector('.masseria-product-form-value');
    }
    connectedCallback() {
      this.addEventListener('change', e => {
        if (e.target.name == 'purchase_option' && e.target.value == 'one-time') {
          this.sellingPlanId = "";
          if (this.sellingPlanIdProductFormInput) {
            this.sellingPlanIdProductFormInput.value = this.sellingPlanId;
          }
          if (this.productFormValue && this.oneTimeVariantId) {
            this.productFormValue.value = this.oneTimeVariantId;
          }
        } else if (e.target.name == 'purchase_option' && e.target.value == 'subscription') {
          this.sellingPlanId = this.querySelector('#masseria-subscription-interval').dataset.planId;
          if (this.sellingPlanIdProductFormInput) {
            this.sellingPlanIdProductFormInput.value = this.sellingPlanId;
          }
          if (this.productFormValue && this.subscriptionId) {
            this.productFormValue.value = this.subscriptionId;
          }
        } else if (e.target.name == 'subscription-interval') {
          if (!this.querySelector('#reserve-in-advance').checked) {
            this.querySelector('#reserve-in-advance').checked = true;
          }

          this.querySelector('#masseria-subscription-interval').dataset.planId = e.target.selectedOptions[0].dataset.sellingPlanId;
          this.sellingPlanId = this.querySelector('#masseria-subscription-interval').dataset.planId;
          if (this.sellingPlanIdProductFormInput) {
            this.sellingPlanIdProductFormInput.value = this.sellingPlanId;
          }
          if (this.salePriceContainer) {
            this.salePriceContainer.innerHTML = e.target.selectedOptions[0].dataset.salePrice;
          }
          if (this.productFormValue && this.subscriptionId) {
            this.productFormValue.value = this.subscriptionId;
          }
        }
      })
    }
  }
)
